import React, { useState, useEffect } from "react";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useLocation } from "react-router-dom";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import AddEmailRecipientForm from "./AddEmailRecipientForm";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import Table from "../../../../components/tables/Table";

import useGetEmailRecipient from "./hooks/useEmailRecipient";
import useGetModules from "./hooks/useGetModules";
import useOperations from "./hooks/useOperations";
import getEmailPermission from "./hooks/getEmailPermission";

import useDeleteEmailRecipient from "./hooks/useDeleteEmailRecipient";
import useUpdateEmailRecipient from "./hooks/useUpdateEmailRecipient";
import {
  addStateEmailRecipient,
  selectedRowsStateEmailRecipient,
} from "./atoms/atoms";
import TableFilters from "./TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import MultiSelectInput from "../../../../components/MultiSelectInput";
import useFieldsOwned from "./hooks/useFieldsOwned";
import useOpsGroupMapping from "./hooks/useOpsGroupMapping";
import useFields from "./hooks/useFields";
import EditButton from "../../../../components/EditButton";
import CancelButton from "../../../../components/CancelButton";
import SaveButton from "../../../../components/SaveButton";
import ShowButton from "../../../../components/ShowButton";
import HideButton from "../../../../components/HideButton";
import EmailRecipientExpandedRow from "./EmailRecipientExpandedRow";
import { useQueryClient } from "react-query";

const EmailRecipientTable = () => {
  //Hooks Call
  const { data } = useGetEmailRecipient();
  const modules = useGetModules();
  const permissions = getEmailPermission();
  const { data: fieldOwned } = useFields();
  const { data: fieldsType } = useFieldsOwned();
  const { data: opsGroupMap } = useOpsGroupMapping();
  const { mutateAsync: UpdateEmailRecipient } = useUpdateEmailRecipient();
  const BulkDeleteEmailRecipient = useDeleteEmailRecipient();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmailRecipient
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateEmailRecipient
  );
  const userAccount = useRecoilValue(accountAtom);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [EmailRecipientIsExist, setEmailRecipientIsExistState] =
    useState(false);
  const [EmailRecipientDataIsChange, setEmailRecipientDataIsChange] =
    useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasEmailRecipient, setHasEmailRecipient] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [filterOperation, setFilterOperation] = useState("");
  const [disabledButton, setDisabledButton] = useState(false);
  const [edit, setEdit] = useState(false);
  const [dropDownModules, setdropDownModules] = useState();
  const [dropDownFields, setdropDownFields] = useState();
  const [defaultModules, setDefaultModules] = useState();
  const [defaultFields, setDefaultFields] = useState();
  const [defaultOperations, setDefaultOperations] = useState();
  const [show, setShow] = useState(false);
  const [, setRowIsExpanded] = useState(false);
  const [editRowData, setEditRowData] = useState();
  const queryClient = useQueryClient();
  const [notifVal, setNotifVal] = useState([]);
  const addPermission = PERMISSIONS.permission_utilities_emailrecipient_add;
  const editPermission = PERMISSIONS.permission_utilities_emailrecipient_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_emailrecipient_delete;

  const userPermissions = useRecoilValue(permissionsSelector);

  const [, sethideColumn] = useState(false);
  const defaultValues = {
    autoEmailNotificationId: 0,
    recipientEmail: "",
    updatedBy: "",
    updatedOn: null,
    isActive: 0,
    createdOn: null,
    createdBy: "",
    fieldIds: [],
    operationIds: [],
    moduleIds: [],
  };
  const [EmailRecipientNewData, setNewData] = useState([defaultValues]);
  const { data: operationsTypeQuery } = useOperations();
  const operationsType =
    operationsTypeQuery &&
    operationsTypeQuery
      .filter((x) => x.isActive)
      .map((x) => {
        return { value: x.operationId, label: x.operationName };
      });
  const [opsChanged, setOpsChanged] = useState(false);
  const [fieldsChanged, setFieldsChanged] = useState(false);
  const [moduleChanged, setModuleChanged] = useState(false);
  const [recipientChanged, setRecipientChanged] = useState(false);

  useEffect(() => {
    setEmailRecipientIsExistState(false);
    setEmailRecipientDataIsChange(false);
    setEditRowId([]);
    setSelectedRows([]);
  }, [setSelectedRows]);

  const handleSelectedRowsChange = (rows) => {
    setSelectedRows(rows.selectedRows);
    setRowsCount(rows.selectedRows.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setEmailRecipientDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? EmailRecipientNewData.map((x) => (x.isActive = true))
      : EmailRecipientNewData.map((x) => (x.isActive = false));
    handleSaveButton();
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmailRecipientIsExistState(false);
    setEmailRecipientDataIsChange(false);

    if (SourceType === "EmailRecipient") {
      if (fieldName === "recipientEmail") {
        EmailRecipientNewData.map(
          (x) => (x.recipientEmail = inputvalue.trim())
        );
        if (
          EmailRecipientNewData[0]?.recipientEmail ===
          editRowData?.recipientEmail
        ) {
          setRecipientChanged(false);
        } else {
          setRecipientChanged(true);
        }
      }
      if (fieldName === "operationsType") {
        EmailRecipientNewData.map((x) =>
          inputvalue != null
            ? (x.operationId = inputvalue)
            : (x.operationId = 0)
        );
      }
      EmailRecipientNewData.map((x) => (x.updatedBy = userAccount.userName));
      handleSaveButton();
    }
  };
  const handleEditButton = (rowData) => {
    setEditRowId(rowData.autoEmailNotificationId);
    setEmailRecipientDataIsChange(false);
    setHasEmailRecipient(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    setEditRowData({ ...rowData });
    setdropDownModules(
      modules.map((m) => {
        return { label: m.moduleName, value: m.id };
      })
    );
    setdropDownFields(
      fieldsType.map((m) => {
        return { label: m.fieldName, value: m.fieldId };
      })
    );
    EmailRecipientNewData.map((x) => (x.isActive = rowData.isActive));
    EmailRecipientNewData.map(
      (x) => (x.recipientEmail = rowData.recipientEmail)
    );
    EmailRecipientNewData.map((x) => (x.operationId = rowData.operationId));
    EmailRecipientNewData.map((x) => (x.fieldId = rowData.fieldId));
    EmailRecipientNewData.map((x) => (x.createdBy = rowData.createdBy));
    EmailRecipientNewData.map((x) => (x.createdOn = rowData.createdOn));
    EmailRecipientNewData.map(
      (x) => (x.autoEmailNotificationId = rowData.autoEmailNotificationId)
    );
    EmailRecipientNewData.map((x) => (x.updatedOn = new Date().toISOString()));
    EmailRecipientNewData.map((x) => (x.updatedBy = userAccount.userName));

    EmailRecipientNewData.map((x) => (x.moduleIds = rowData.moduleIds));
    const filteredPermission = permissions.filter(
      (item) => item.autoEmailNotificationId === rowData.autoEmailNotificationId
    );
    const filteredFields =
      fieldOwned &&
      fieldOwned.filter(
        (item) =>
          item.emailRecipientId === rowData.autoEmailNotificationId &&
          item.isActive === true
      );

    const filteredOpsGroupMap =
      opsGroupMap &&
      opsGroupMap.filter(
        (item) =>
          item.autoEmailNotificationId === rowData.autoEmailNotificationId &&
          item.isActive === true
      );

    const mod = filteredPermission
      ?.filter((c) => c.moduleId !== 0)
      .map((m) => {
        return { label: m.moduleName, value: m.moduleId };
      });
    const field = filteredFields.map((m) => {
      return { label: m.fieldName, value: m.fieldId };
    });
    const operation = filteredOpsGroupMap.map((x) => {
      return { label: x.operationName, value: x.operationId };
    });
    const defaultModule = [];
    const defaultField = [];
    const defaultOps = [];
    mod.forEach((m) => {
      defaultModule.push(m.value);
    });
    field.forEach((m) => {
      defaultField.push(m.value);
    });
    operation.forEach((m) => {
      defaultOps.push(m.value);
    });

    if (defaultModule[0] !== []) {
      EmailRecipientNewData.map((x) => (x.moduleIds = defaultModule));
      setDefaultModules(mod);
    }
    if (defaultField[0] !== []) {
      EmailRecipientNewData.map((x) => (x.fieldIds = defaultField));
      setDefaultFields(field);
    }
    if (defaultOps[0] !== []) {
      EmailRecipientNewData.map((x) => (x.operationIds = defaultOps));
      setDefaultOperations(operation);
    }
    sethideColumn(false);
  };

  //Save changes
  const handleSave = (EmailRecipientNewData) => {
    if (EmailRecipientDataIsChange) {
      if (!EmailRecipientIsExist) {
        UpdateEmailRecipient(EmailRecipientNewData, {
          onSuccess: (res) => {
            if (res === "Duplicate") {
              toast.fire("Failed", "The data already exists!", "error");
              setOpenModalEdit(false);
              setActionEditState(false);
              setEditRowId([]);
              setDefaultModules([]);
              setEmailRecipientDataIsChange(false);
              setEmailRecipientIsExistState(false);
              setDisabledButton(false);
              sethideColumn(false);
              setEdit(false);
            } else {
              queryClient.invalidateQueries("GetEmailRecipient");
              queryClient.invalidateQueries(["EmailPermission"]);
              queryClient.invalidateQueries("GetFieldsOwned");
              queryClient.invalidateQueries("Operations");
              queryClient.invalidateQueries("GetFields");
              queryClient.invalidateQueries("GetOperationGroupMapping");
              toast.fire(
                "Success",
                "Email Recipient Updated Successfully",
                "success"
              );
              setOpenModalEdit(false);
              setNewData([defaultValues]);
              setEditRowId([]);
              setSelectedRows([]);
              setActionEditState(false);
              setDisabledButton(false);
              sethideColumn(false);
              setEdit(false);
            }
          },
          onError: () => {
            toast.fire("Failed", "Failed to Update Email Recipient", "error");
            setOpenModalEdit(false);
          },
        });
      }
    }
  };

  const handleMultiSelectModule = (checkedModules) => {
    const module = [];
    checkedModules.forEach((m) => {
      module.push(m.value);
    });
    setEmailRecipientDataIsChange(true);
    EmailRecipientNewData.map((x) => (x.moduleIds = module));
    //Order arrays
    const sortedmodule = module.slice().sort();
    const sortedModuleIds = editRowData?.moduleIds.slice().sort();
    //Check if there's a changes
    if (JSON.stringify(sortedmodule) === JSON.stringify(sortedModuleIds)) {
      setModuleChanged(false);
    } else {
      setModuleChanged(true);
    }
    handleSaveButton();
  };
  const handleMultiSelectFields = (checkedFields) => {
    const field = [];
    checkedFields.forEach((m) => {
      field.push(m.value);
    });
    setEmailRecipientDataIsChange(true);
    EmailRecipientNewData.map((x) => (x.fieldIds = field));

    //Order arrays
    const sortedField = field.slice().sort();
    const sortedFieldsOwnIds = editRowData?.fieldsOwnIds.slice().sort();
    //Check if there's a changes
    if (JSON.stringify(sortedField) === JSON.stringify(sortedFieldsOwnIds)) {
      setFieldsChanged(false);
    } else {
      setFieldsChanged(true);
    }
    handleSaveButton();
  };
  const handleMultiSelectOperations = (checkedOps) => {
    const ops = [];
    checkedOps.forEach((m) => {
      ops.push(m.value);
    });
    setEmailRecipientDataIsChange(true);
    EmailRecipientNewData.map((x) => (x.operationIds = ops));

    //Order arrays
    const sortedOps = ops.slice().sort();
    const sortedOpsIds = editRowData?.operationIds.slice().sort();
    //Check if there's a changes
    if (JSON.stringify(sortedOps) === JSON.stringify(sortedOpsIds)) {
      setOpsChanged(false);
    } else {
      setOpsChanged(true);
    }
    handleSaveButton();
  };
  //handle save button
  const handleSaveButton = () => {
    setEmailRecipientDataIsChange(true);
    EmailRecipientNewData.map((x) =>
      x.recipientEmail !== ""
        ? setHasEmailRecipient(true)
        : setHasEmailRecipient(false)
    );
  };
  // end of saving changes
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#edebeb",
      minHeight: "28px",
      //   height: "9px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
    }),
    menuPortal: (base) => ({ ...base, position: "absolute", zIndex: 9999 }),
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.autoEmailNotificationId);
    BulkDeleteEmailRecipient(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Email Recipients" : "Email Recipient"
    }?`}</div>
  );
  const validate = (text) => {
    const reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (reg.test(text) === false) {
      return false;
    } else {
      return true;
    }
  };

  const ExpandRow = (rowData) => {
    //For multiple filtered records
    if (recipientId?.includes(".")) {
      notifVal.map((item) => {
        if (item.autoEmailNotificationId === rowData.autoEmailNotificationId)
          item.expandRow = !item.expandRow;
        return { ...item };
      });
      setShow(!show);
    }
    //For single filtered record
    else if (notifVal?.length === 1) {
      notifVal.map((item) => {
        if (item.autoEmailNotificationId === rowData.autoEmailNotificationId)
          item.expandRow = !item.expandRow;
        return { ...item };
      });
      setShow(!show);
    }
    //For all record
    else {
      setShow(!show);
      data.map((item) => {
        if (item.autoEmailNotificationId === rowData.autoEmailNotificationId)
          item.expandRow = !item.expandRow;
        return { ...item };
      });
    }
  };

  const matColumns = [
    {
      name: "Email Recipient",
      field: "recipientEmail",
      cell: (rowData) => {
        return rowData.autoEmailNotificationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer w-full status-space">
            <TextInput
              placeholder="Email Recipient"
              defaultValue={rowData.recipientEmail}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "EmailRecipient",
                  "recipientEmail",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.recipientEmail}</>
        );
      },
    },
    {
      name: "Operations Group",
      field: "operationName",

      cell: (rowData) => {
        return rowData.autoEmailNotificationId === editRowId ? (
          <div className="w-full ">
            <div className="">
              <MultiSelectInput
                menuPortalTarget={document.body}
                styles={customStyles}
                isMulti
                defaultValue={defaultOperations}
                closeMenuOnSelect={false}
                options={operationsType}
                className="basic-multi-select"
                classNamePrefix="select"
                handleMultiSelect={handleMultiSelectOperations}
              />
            </div>
          </div>
        ) : (
          <>
            {rowData.operationName?.includes("amp;")
              ? rowData.operationName.replaceAll("amp;", " ")
              : rowData.operationName}
          </>
        );
      },
    },
    {
      name: "Fields Owned",
      field: "fieldsOwned",

      cell: (rowData) => {
        return rowData.autoEmailNotificationId === editRowId ? (
          <div className="w-full">
            {/* <div className="border border-white-200" /> */}

            <MultiSelectInput
              menuPortalTarget={document.body}
              defaultValue={defaultFields}
              styles={customStyles}
              isMulti
              closeMenuOnSelect={false}
              options={dropDownFields}
              className="basic-multi-select flex flex-col"
              classNamePrefix="select"
              handleMultiSelect={handleMultiSelectFields}
            />
          </div>
        ) : (
          <>
            {rowData.fieldsOwned?.includes("amp;")
              ? rowData.fieldsOwned.replaceAll("amp;", " ")
              : rowData.fieldsOwned}
          </>
        );
      },
    },
    {
      name: "Module",
      field: "modules",

      cell: (rowData) => {
        return rowData.autoEmailNotificationId === editRowId ? (
          <div className="w-full ">
            {/* <div className="border border-white-200" /> */}

            <MultiSelectInput
              menuPortalTarget={document.body}
              defaultValue={defaultModules}
              styles={customStyles}
              isMulti
              closeMenuOnSelect={false}
              options={dropDownModules}
              className="basic-multi-select"
              classNamePrefix="select"
              handleMultiSelect={handleMultiSelectModule}
            />
          </div>
        ) : (
          <>
            {rowData.modules?.includes("amp;")
              ? rowData.modules.replaceAll("amp;", " ")
              : rowData.modules}
          </>
        );
      },
    },
    {
      name: "Status",
      field: "isActive",

      cell: (rowData) => {
        return rowData.autoEmailNotificationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans uppercase mr-4">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      name: "Action/s",
      center: true,
      cell: (rowData) => {
        const noChanges =
          EmailRecipientNewData[0]?.isActive === editRowData?.isActive &&
          !recipientChanged &&
          !moduleChanged &&
          !fieldsChanged &&
          !opsChanged;
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.autoEmailNotificationId === editRowId ? (
          <div className="flex justify-center gap-2 ">
            <div className="flex gap-2 sm:flex-col md:flex-col 1xl:flex-row justify-items-center">
              <SaveButton
                className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${!hasEmailRecipient || noChanges ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasEmailRecipient || noChanges}
                onClick={() => {
                  const validEmail = validate(
                    EmailRecipientNewData[0].recipientEmail
                  );
                  if (validEmail) {
                    setOpenModalEdit(true);
                    sethideColumn(false);
                  } else {
                    toast.fire("Saving Failed", "Email is Invalid!", "warning");
                  }
                }}
              />
              <CancelButton
                className="flex text-xs shadow-md font-semibold text-white gap-x-1 rounded-full w-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
                onClick={() => {
                  setActionEditState(false);
                  setEditRowId([]);
                  setDefaultModules([]);
                  setEmailRecipientDataIsChange(false);
                  setEmailRecipientIsExistState(false);
                  setDisabledButton(false);
                  sethideColumn(false);
                  setEdit(false);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="flex items-center place-content-center">
            <div className="">
              {rowData.expandRow ? (
                <HideButton
                  className=""
                  buttonText="Hide"
                  isDisabled={(show, edit)}
                  onClick={() => {
                    ExpandRow(rowData);
                  }}
                />
              ) : (
                <div className="flex gap-2 sm:flex-col xl:flex-row justify-items-center">
                  <ShowButton
                    buttonText="Show"
                    className={
                      (show || selectedRows.length > 0
                        ? "opacity-50 rounded-full space-x-2 items-center bg-quaternary hover:bg-tertiary text-white"
                        : edit
                        ? "opacity-50"
                        : "") +
                      " border  text-white bg-quinary border-quinary  "
                    }
                    disabled={
                      show || selectedRows.length > 0 || edit ? true : false
                    }
                    onClick={() => {
                      ExpandRow(rowData);
                      //setShow(true);
                      setRowIsExpanded(true);
                    }}
                  />
                  {userPermissions.includes(editPermission) ? (
                    <EditButton
                      disabled={
                        show || disabledButton || selectedRows.length > 0
                      }
                      className={
                        show || disabledButton || selectedRows.length > 0
                          ? "opacity-50 "
                          : "opacity-100 "
                      }
                      onClick={() => {
                        setDisabledButton(true);
                        setActionEditState(true);
                        handleEditButton(rowData);
                        sethideColumn(true);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </div>
        );
      },
    },
  ];

  //Filters
  const filteredItems =
    filterOperation !== null
      ? data
        ? data.filter(
            (item) =>
              item.recipientEmail &&
              item.recipientEmail
                ?.toLowerCase()
                ?.includes(filterText?.trim()?.toLowerCase()) &&
              item.operationName
                ?.toLowerCase()
                ?.includes(filterOperation?.toLowerCase())
          )
        : []
      : data
      ? data.filter(
          (item) =>
            item.recipientEmail &&
            item.recipientEmail
              ?.toLowerCase()
              ?.includes(filterText?.trim()?.toLowerCase())
        )
      : [];

  //Filters
  let recordIdFromRecent = "";
  let location = useLocation();
  const [recipientId, setRecipientId] = useState("");
  useEffect(() => {
    if (location.state != null) {
      recordIdFromRecent = location.state;
      notificationFilterById(
        recordIdFromRecent.recordId,
        recordIdFromRecent.moduleName,
        recordIdFromRecent.subModuleName
      ).then(() => {
        setRecipientId(recordIdFromRecent.recordId);
      });
    }
    if (recipientId?.includes(".")) {
      let recipientIds = recipientId.split(".");
      const idsArr = recipientIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        idsArr.includes(x.autoEmailNotificationId)
      );
      setNotifVal(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.autoEmailNotificationId === Number(recipientId)
      );
      setNotifVal(filteredData);
    }
  }, [recipientId, data, recordIdFromRecent]);

  return (
    <div className="animate-fade-in-down">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase py-4"> </div>
      )}
      {!actionAddState && (
        <div className="">
          <div className="w-full mb-4">
            <div className="flex flex-row justify-between">
              <div className="flex flex-row item-center ml-4 -mt-4 space-x-2">
                <TableFilters
                  operationsType={operationsType}
                  filterText={setFilterText}
                  filterOperation={setFilterOperation}
                  moduleDetails="Email Recipient"
                  textInputName="recipientEmail"
                  disabledButton={disabledButton || selectedRows.length > 0}
                  //For filtered refresh data
                  setNotifVal={setNotifVal}
                ></TableFilters>
              </div>
              <div className="mr-4 -mt-4">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    buttonText="New Email Recipient"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            {userPermissions.includes(deletePermission) ? (
              <div className="text-secondary italic text-xs3 my-2 mx-4">
                {!edit ? (
                  <div>
                    <p className="font-bold italic inline-block mr-1">Note: </p>
                    Tick the box to deactivate some data.
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              ""
            )}
            <div className="m-4 content-center">
              <Table
                columns={matColumns}
                data={
                  notifVal?.length > 0
                    ? notifVal
                    : data
                    ? filterOperation !== null || filterText !== ""
                      ? filteredItems
                      : data
                    : []
                }
                options={{
                  toolbar: false,
                  showname: false,
                }}
                deletePermission={userPermissions.includes(deletePermission)}
                selectableRows={userPermissions.includes(deletePermission)}
                setOpenModal={setOpenModalDelete}
                onSelectedRowsChange={handleSelectedRowsChange}
                setIsBulkSelected={setIsBulkSelected}
                selectedRows={selectedRows}
                selectableRowDisabled={(row) => !row.isActive}
                isDeactive={true}
                expandableRows
                expandableRowsComponent={(rowData) =>
                  show ? <EmailRecipientExpandedRow data={rowData.data} /> : ""
                }
                expandableRowExpanded={(rowData) => rowData.expandRow}
              />
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Update Email Recipient"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => setOpenModalEdit(false)}
            onClickFunction={() => {
              handleSave(EmailRecipientNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Email Recipient"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </div>
      )}
      {actionAddState && (
        <div className="p-4">
          <AddEmailRecipientForm />
        </div>
      )}
    </div>
  );
};

export default EmailRecipientTable;
